export default "__VITE_ASSET__Cb3$f5Qc__"